// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'passbook';

export const Component = () => (
  <path d='M24.042 1.461H.48C.335.84.239.84.096 1.51c-.048.144-.048.287-.096.479v22.079h24.521V1.987c-.096-.67-.191-1.005-.287-.957-.048.048-.144.191-.192.431ZM.958 15.685V8.837h7.854c0 .958.336 1.772 1.006 2.442.67.67 1.484 1.006 2.442 1.006.958 0 1.772-.336 2.442-1.006.67-.67 1.006-1.484 1.006-2.442h7.854v6.848H.957Zm0-13.218h22.605V7.88h-8.381c-.144-.622-.239-.67-.383-.047-.047.143-.047.287-.096.526 0 .67-.239 1.245-.719 1.724a2.354 2.354 0 0 1-1.724.719 2.35 2.35 0 0 1-1.724-.719 2.354 2.354 0 0 1-.719-1.724c-.096-.623-.191-.958-.287-.958-.048 0-.144.144-.192.48H.957V2.466Zm22.605 20.594H.958v-6.37h22.605v6.37Z' />
);

export const viewBox = '0 0 25 25';
